export default __webpack_public_path__ + "static/media/elevate-lav-2.7181eabc.png";